import {
  Container,
  Grid,
  Title,
  Image,
  Center,
  Overlay,
  Box,
  Text,
  Modal,
  Button,
  List,
} from "@mantine/core";
import { useState } from "react";
import { Carousel } from "@mantine/carousel";
import classes from "./Projects.module.css";
import { Element } from "react-scroll";
const importAll = (r) => r.keys().map(r);
const projectImages = importAll(
  require.context("../../assets/images/project", false, /\.(png|jpg|jpeg|svg)$/)
);

const images = [
  {
    title: "Monitoring PT. Indospring Tbk application",
    description: ["Company : PT. Indospring Tbk", "As a fullstack developer", "Develop using laravel framework"],
    link: "#",
  },
  {
    title: "PKM Application",
    description: ["Company: Universitas Dinamika", "As a fullstack developer", "Develop using laravel framework"],
    link: "#",
  },
  {
    title: "Ecommerce Koperasi PT. Indospring Tbk application",
    description: ["Company: PT. Indospring Tbk", "As a fullstack developer", "Develop using laravel framework"],
    link: "#",
  },
  {
    title: "ERP Garment Application",
    description: ["Company : Burning Room", "As a fullstack developer", "Develop using laravel framework"],
    link: "#",
  },
];

export default function Projects() {
  const [opened, setOpened] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  // Fungsi untuk membuka modal dengan data yang diklik
  const openModal = (index) => {
    setSelectedProject(images[index]);
    setOpened(true);
  };

  return (
    <Element name="projects">
      <Container size="lg" mt={50} py={50}>
        <Grid justify="center" style={{ paddingTop: "2rem" }}>
          <Grid.Col span={12}>
            <Center>
              <Title order={2} align="center">
                Projects that showcase my expertise in software engineering
              </Title>
            </Center>
          </Grid.Col>

          <Grid.Col span={12} md={8}>
            <Carousel
              slideSize="100%"
              // height={300}
              align="center"
              // slideGap="md"
              loop
              withIndicators
              controlSize={"40"}
              classNames={{
                root: classes.carousel,
                indicator: classes.carouselIndicator,
              }}
            >
              {projectImages.map((src, index) => (
                <Carousel.Slide key={index}>
                  <Image src={src} alt={`Project ${index + 1}`} radius="md" />
                  <Overlay
                    opacity={0}
                    color="#000"
                    zIndex={1}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                    }}
                  />
                  <Box
                    style={{
                      position: "absolute",
                      bottom: "10%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 2,
                      color: "black",
                      textAlign: "center",
                      width: "80%",
                    }}
                  >
                    <Button
                      mt="md"
                      style={{ cursor: "pointer" }}
                      onClick={() => openModal(index)}
                    >
                      Detail Project
                    </Button>
                  </Box>
                </Carousel.Slide>
              ))}
            </Carousel>
          </Grid.Col>

          {/* Modal untuk menampilkan detail */}
          <Modal
            opened={opened}
            onClose={() => setOpened(false)}
            title="Detail Project"
            size="lg"
            centered
            transitionTimingFunction="ease-in-out"
          >
            {selectedProject && (
              <Box>
                <Text mt="md" size="lg" weight={700}>
                  {selectedProject.title}
                </Text>
                <List>
                  {selectedProject.description.map((val) => (
                    <List.Item>
                      <Text size="md" weight={400}>
                        {val}
                      </Text>
                    </List.Item>
                  ))}
                </List>
              </Box>
            )}
          </Modal>
        </Grid>
      </Container>
    </Element>
  );
}
